import Image from 'components/medias/Image';
import {ShareFolderSharedOwnerIcon, ShareFolderSharedIcon, ShareFolderIcon} from 'assets/icons/share_folder_icons';
import { type SharedFolder } from 'types';
import useSmallDesktopScreen from 'hooks/useSmallDesktopScreen';
import { useWebUserContext, useSelectedLinkContext } from 'contexts';

type FolderItemIconProps = {
  folder: SharedFolder;
};

const FolderItemIcon = ({ folder } : FolderItemIconProps) : JSX.Element | null => {
  const { selectedLink } = useSelectedLinkContext();
  const { webUser } = useWebUserContext();
  const isSmallScreen = useSmallDesktopScreen();
  const width = isSmallScreen ? '50px' : 'auto';

  let props = {alt: 'Dossier', src: ShareFolderIcon};

  const isSharedFolder = folder.sharedWith.filter((contact) => contact.id !== webUser.id).length > 0;

  if (isSharedFolder) {
    if (selectedLink?.userKey === folder.creator) {
      props = {alt: 'Dossier partagé possédé', src: ShareFolderSharedOwnerIcon};
    } else {
      props = {alt: 'Dossier partagé non possédé', src: ShareFolderSharedIcon};
    }
  }

  return <Image width={width} {...props} />;
};

export default FolderItemIcon;